'use client';

import dynamic from 'next/dynamic';
import { SectLabel } from '@/components/landing/v4-shared';
import { VOICE_WIDGET_COPY } from '@/lib/simple-setup/customer-wins';
import { V4_BRAND } from '@/lib/marketing/messaging-bank';

const FloatingVoiceV1 = dynamic(
  () => import('@/components/voice/FloatingVoiceV1'),
  { ssr: false }
);

export function VoiceWidgetSection() {
  return (
    <section className="relative" style={{ paddingTop: 112, paddingBottom: 112 }}>
      <div className="v4-sp-section-rule absolute top-0 inset-x-0" aria-hidden="true" />
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="mb-5" style={{ display: 'inline-flex' }}>
          <SectLabel color="var(--cyan-glow)">{VOICE_WIDGET_COPY.eyebrow}</SectLabel>
        </div>
        <h2
          style={{
            fontFamily: 'var(--font-geist-sans)',
            fontSize: 'clamp(28px, 4.5vw, 56px)',
            fontWeight: 500,
            letterSpacing: '-0.025em',
            color: 'var(--paper)',
            lineHeight: 1.1,
            marginBottom: 24,
            marginTop: 0,
          }}
        >
          Talk to Bri{' '}
          <em
            style={{
              fontFamily: 'var(--font-instrument)',
              fontStyle: 'italic',
              color: 'var(--cyan-glow)',
              fontWeight: 400,
            }}
          >
            right now
          </em>
        </h2>
        <p
          style={{
            fontFamily: 'var(--font-geist-sans)',
            fontSize: 'clamp(15px, 1.8vw, 18px)',
            lineHeight: 1.55,
            color: 'rgba(244,244,240,0.78)',
            marginBottom: 48,
            maxWidth: '40ch',
            marginInline: 'auto',
          }}
        >
          {VOICE_WIDGET_COPY.lede}
        </p>

        <div className="flex justify-center" data-campaign="simple-setup">
          <FloatingVoiceV1
            surface="simple_setup"
            variant="centered-ring"
            postCall={{ mode: 'cta', href: V4_BRAND.postDemoCtaHref, label: 'Get started' }}
          />
        </div>

        <p
          style={{
            marginTop: 32,
            fontFamily: 'var(--font-geist-mono)',
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: '0.22em',
            color: 'var(--dim)',
          }}
        >
          {VOICE_WIDGET_COPY.microcopy}
        </p>
      </div>
    </section>
  );
}
